import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { fontFamilyAll } from "../assets/commonComponents/COLORS";

const ServicesSection = ({ data }) => {
  return (
    <Box sx={{ flexGrow: 1, py: 5 }}>
      <Grid container spacing={4} justifyContent="center">
        {data.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} textAlign="center">
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Box sx={{ mb: 1 }}>
                <img src={service.icon} alt={service.title} width="50" height="50" />
              </Box>
              <Box sx={{ mt: 5 }}>
                <Typography variant="h5" fontWeight="bold" fontFamily={fontFamilyAll}>
                  {service.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ maxWidth: "300px" }} textAlign={"justify"} fontFamily={fontFamilyAll}>
                  {service.description}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ServicesSection;
